import React from 'react'
import classNames from 'classnames'

const RelatedPagesInFolder = props => {
  const { relatedPagesInFolder } = props
  if (!relatedPagesInFolder.length) return null
  return relatedPagesInFolder.map((item, key) => {
    if (!item.description || !item.link || !item.title) return null
    const imageDom = item.image ? <div className='col-sm-3 img-responsive'><img src={item.image} /></div> : null
    const h3Classes = classNames({
      'prod-title': true,
      'col-sm-9': imageDom
    })
    return (
      <div key={key} className='panel panel-primary' data-updateddate={item.date}>
        <div className='panel-body'>
          <div className='row'>
            {imageDom}
            <h3 className={h3Classes}>
              <a href={item.link} data-toggle='modal.pane'>{item.text}</a>
            </h3>
          </div>
          <p className='small text-muted mb-0 product-description'>{item.description}</p>
        </div>
      </div>
    )
  })
}

export default RelatedPagesInFolder



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/destinations/relatedPagesInFolder.jsx